import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatSelect, MatSelectChange} from '@angular/material/select';
import {notify} from '../../notification/notfication.actions';
import {AppStore} from '../../store/store';
import {UserModel} from '../../user/user.model';
import {userSelector} from '../../user/user.reducer';
import {UserService} from '../../user/user.service';
import {PartnerModel} from '../partner.model';
import {partnerListSelector} from '../partner.reducer';
import {PartnerService} from '../partner.service';
import {SubSink} from 'subsink';

@Component({
  selector: 'app-partner-select',
  template: `
    <mat-form-field>
      <mat-select #partnerSelectElement
                  data-cy="select-partner"
                  placeholder="Partner"
                  [formControl]="partnerSelectForm"
                  (selectionChange)="onChange($event)">
        <mat-option *ngFor="let partner of partners" [value]="partner.id">{{partner.name}} ({{partner.id}})</mat-option>
      </mat-select>
    </mat-form-field>
  `,
  styleUrls: ['select.component.scss']
})
export class PartnerSelectComponent implements OnInit, OnDestroy {

  @Output() partnerSelect = new EventEmitter<PartnerModel>();

  @ViewChild('partnerSelectElement') partnerSelectElement!: MatSelect;

  partners!: PartnerModel[];

  user!: UserModel;

  partnerSelectForm = new FormControl('');

  subsink = new SubSink();

  constructor(private appStore: AppStore,
              private userService: UserService,
              private partnerService: PartnerService) {
  }

  ngOnInit() {
    this.user = userSelector(this.appStore.getState());
    this.partnerSelectForm.setValue(this.user.partnerId);
    this.subsink.sink = this.appStore.subscribe((state: AppStore) => {
      this.user = userSelector(this.appStore.getState());
      this.partners = partnerListSelector(state);
      if (this.user && this.user.partnerId) {
        this.partnerSelectForm.setValue(this.user.partnerId);
      }
    });

    this.partnerService.getPartnerList();
  }

  onChange(event: MatSelectChange) {
    const partnerId = parseInt(event.value, 10);
    this.user.partnerId = partnerId;
    this.userService.changePartner(this.user);
    const selectedPartner = this.partners.find((p: PartnerModel) => {
      return p.id === partnerId;
    })?.name;
    notify(this.appStore, `Partner "${selectedPartner}" selected`);
    this.partnerSelect.emit();
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

}
